import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import ComingSoonFormat from "@/components/competitions/ComingSoonFormat";
import FFALoader from "@/components/FFALoader";
import {
  useCompetitionFormatSettings,
  isFormatEnabled,
  formatComingSoonMessage,
} from "@/hooks/useCompetitionFormatSettings";

interface Props {
  format: string;
  label: string;
  children: ReactNode;
}

/**
 * Route-level guard: blocks arena pages for competition formats that admins
 * have disabled in Competition Type Settings, showing the configured
 * "Coming Soon" message instead.
 */
export default function FormatGate({ format, label, children }: Props) {
  const { data, isLoading } = useCompetitionFormatSettings();
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <FFALoader />
      </div>
    );
  }

  if (!isFormatEnabled(data, format)) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center px-4 gap-4">
        <ComingSoonFormat
          formatLabel={label}
          message={formatComingSoonMessage(data, format)}
        />
        <Button variant="outline" onClick={() => navigate("/dashboard")} className="gap-2">
          <ArrowLeft className="w-4 h-4" /> Back to Dashboard
        </Button>
      </div>
    );
  }

  return <>{children}</>;
}
